var $0994847e6d27862d$exports = {};
$0994847e6d27862d$exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};


export {$0994847e6d27862d$exports as default};
//# sourceMappingURL=et-EE.module.js.map
